import React from 'react';
import styled from 'styled-components';

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
`;

const InputContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
`;

const StyledInput = styled.input`
  width: 100%;
  padding: 0.75rem 1.25rem;
  background: ${({ theme }) => theme.inputBg};
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 9999px;
  color: #000000;
  font-size: 1rem;
  transition: all 0.3s ease;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.primary};
    box-shadow: 0 0 0 2px ${({ theme }) => `${theme.primary}33`};
    background: ${({ theme }) => theme.inputBg};
  }

  &:disabled {
    background: ${({ theme }) => theme.disabledBg};
    cursor: not-allowed;
  }

  &::placeholder {
    color: #888888;
  }

  ${({ error, theme }) =>
    error &&
    `
    border-color: #ff4d4f;
    &:focus {
      border-color: #ff4d4f;
      box-shadow: 0 0 0 3px #ff4d4f20;
      background: ${theme.inputBg};
    }
  `}

  @media (max-width: 768px) {
    padding: 10px 14px;
    font-size: 14px;
  }
`;

const SuffixWrapper = styled.div`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  height: 100%;
  padding: 0 8px;
  
  svg {
    font-size: 18px;
  }
`;

const Label = styled.label`
  color: ${({ theme }) => theme.text};
  font-size: 0.875rem;
  font-weight: 500;
  margin-left: 0.5rem;
`;

const ErrorText = styled.span`
  display: block;
  margin-top: 4px;
  font-size: 12px;
  color: #ff4d4f;
`;

const Input = ({
  label,
  error,
  type = 'text',
  disabled = false,
  value,
  onChange,
  placeholder,
  suffix,
  ...props
}) => {
  return (
    <InputWrapper>
      {label && <Label>{label}</Label>}
      <InputContainer>
        <StyledInput
          type={type}
          disabled={disabled}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          error={error}
          style={{ paddingRight: suffix ? '40px' : '1.25rem' }}
          {...props}
        />
        {suffix && <SuffixWrapper>{suffix}</SuffixWrapper>}
      </InputContainer>
      {error && <ErrorText>{error}</ErrorText>}
    </InputWrapper>
  );
};

export default Input;